/**
 * Entry point. Pure client-side render — no SSR, no hydration.
 *
 * Provider order matters:
 *   QueryClientProvider  → server-state cache
 *     SessionProvider    → uses the api client (which the cache's queries also use)
 *       Router           → nothing renders until the session boot settles
 */
import { render } from "solid-js/web";
import { Router } from "@solidjs/router";
import { QueryClientProvider } from "@tanstack/solid-query";

import { queryClient } from "~/core/query/client";
import { SessionProvider } from "~/core/auth/session";
import { AppRoot, routes } from "~/app";

import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "./app.css";

const root = document.getElementById("root");
if (!root) throw new Error('Missing #root — index.html must contain <div id="root">.');

render(
  () => (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <Router root={AppRoot}>{routes()}</Router>
      </SessionProvider>
    </QueryClientProvider>
  ),
  root,
);
